module.exports = {"id":"137506","name":"Goran Pandev","rating":"74","photo":"./data/images/photos/0/137506.png","club":{"name":"Genoa","logo":"./data/images/clubs/Genoa.png"},"positions":["BU","MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GoranPandev0.json
// module id = 1629
// module chunks = 0